import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { RedirectService } from '../services/redirect.service';

export const redirectGuard: CanActivateFn = (route, state) => {
  const platformId = inject(PLATFORM_ID);
  
  // Skip on server-side (SSR) - IIS handles redirects for initial requests
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const redirectService = inject(RedirectService);
  const router = inject(Router);

  const urlPath = state.url.split('?')[0].split('#')[0];
  const result = redirectService.checkRedirect(urlPath);

  if (result.hasRedirect && result.targetUrl) {
    const queryParamIndex = state.url.indexOf('?');
    const hashIndex = state.url.indexOf('#');
    let targetUrl = result.targetUrl;

    // Preserve query params from the original URL when the target doesn't specify them
    if (queryParamIndex > -1 && !targetUrl.includes('?')) {
      const endIndex = hashIndex > -1 && hashIndex > queryParamIndex ? hashIndex : state.url.length;
      targetUrl += state.url.substring(queryParamIndex, endIndex);
    }

    // Preserve fragment from the original URL when the target doesn't specify one
    if (hashIndex > -1 && !targetUrl.includes('#')) {
      targetUrl += state.url.substring(hashIndex);
    }

    if (result.isExternal) {
      window.location.href = targetUrl;
      return false;
    }

    return router.parseUrl(targetUrl);
  }

  return true;
};
